module.exports = __webpack_public_path__ + "img/grocer-mate-bg.a1de5696.png";